<business-units-select-page-header></business-units-select-page-header>

<div class="container-fluid page-container">
    <ng-container *ngIf="!(payLaterFeatureFlag$ | async)">
        <div class="row">
            <div
                class="overview-column"
                [class.col-3]="(screenWidthPx$ | async | notNull) >= 1280"
                [class.col-6]="
                    (screenWidthPx$ | async | notNull) < 1280 &&
                    (screenWidthPx$ | async | notNull) >= 768
                "
                [class.col-12]="(screenWidthPx$ | async | notNull) < 768"
            >
                <account-credit-summary-tile
                    id="credit-summary-tile"
                    [dataSource]="creditSummaryDataSource"
                ></account-credit-summary-tile>
            </div>
            <div
                class="overview-column"
                [class.col-3]="(screenWidthPx$ | async | notNull) >= 1280"
                [class.col-6]="
                    (screenWidthPx$ | async | notNull) < 1280 &&
                    (screenWidthPx$ | async | notNull) >= 768
                "
                [class.col-12]="(screenWidthPx$ | async | notNull) < 768"
            >
                <account-supplier-summary-tile
                    id="supplier-summary-tile"
                    [dataSource]="supplierOverviewDataSource"
                    [isBuyerAccount]="!(isBuyerUser$ | async)"
                ></account-supplier-summary-tile>
            </div>
            <div
                class="overview-column"
                [class.col-6]="(screenWidthPx$ | async | notNull) >= 1280"
                [class.col-12]="(screenWidthPx$ | async | notNull) < 1280"
            >
                <account-invoice-summary-tile
                    id="invoice-summary-tile"
                    [dataSource]="invoiceSummaryDataSource"
                ></account-invoice-summary-tile>
            </div>
        </div>
        <div class="row">
            <div class="overview-column col-12 col-lg-6">
                <account-payments-summary-tile
                    id="payments-summary-tile"
                    [dataSource]="paymentsSummaryDataSource"
                ></account-payments-summary-tile>
            </div>
            <div class="overview-column col-12 col-lg-6">
                <account-spend-volume-tile id="spend-volume-tile"> </account-spend-volume-tile>
            </div>
        </div>
        <div class="row" *ngIf="!(isBuyerUser$ | async)">
            <div class="overview-column col-12">
                <account-business-units-table
                    [dataSource]="businessUnitsTableDataSource"
                ></account-business-units-table>
            </div>
        </div>
        <div class="row" *ngIf="isBuyerUser$ | async">
            <div class="overview-column col-12 col-xl-6">
                <buyer-invoices-payable-table
                    [listInvoicesDataSource]="topAgingInvoicesTableDataSource"
                >
                </buyer-invoices-payable-table>
            </div>
            <div class="overview-column col-12 col-xl-6">
                <early-payment-table
                    [listSuppliersDataSource]="suppliersTableDataSource"
                ></early-payment-table>
            </div>
        </div>
    </ng-container>

    <ng-container *ngIf="payLaterFeatureFlag$ | async">
        <ng-container *ngIf="isPayLaterEnabledForBuyer$ | async">
            <div class="row">
                <div
                    class="overview-column"
                    [class.col-3]="(screenWidthPx$ | async | notNull) >= 1280"
                    [class.col-6]="
                        (screenWidthPx$ | async | notNull) < 1280 &&
                        (screenWidthPx$ | async | notNull) >= 768
                    "
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 768"
                >
                    <flex-term-availability-tile
                        id="flex-term-availability-tile"
                        [dataSource]="flexTermAvailabilityData$"
                        [flexTermUrl]="flexTermUrl"
                        [showRequestButton]="isBuyerUser$ | async | notNull"
                    ></flex-term-availability-tile>
                </div>
                <div
                    class="overview-column"
                    [class.col-6]="(screenWidthPx$ | async | notNull) >= 768"
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 768"
                >
                    <facility-utilization-ft-tile
                        id="facility-utilization-ft-tile"
                        [earlyPaymentDataSource]="facilityUtilizationData"
                        [flexTermDataSource]="flexTermFacilityUtilizationData"
                    ></facility-utilization-ft-tile>
                </div>

                <div
                    class="overview-column"
                    [class.col-3]="(screenWidthPx$ | async | notNull) > 1280"
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 1280"
                >
                    <account-supplier-summary-tile
                        id="supplier-summary-tile"
                        [dataSource]="supplierOverviewDataSource"
                        [isBuyerAccount]="!(isBuyerUser$ | async)"
                    ></account-supplier-summary-tile>
                </div>
            </div>

            <div class="row">
                <div
                    class="overview-column"
                    [class.col-6]="(screenWidthPx$ | async | notNull) >= 1630"
                    [class.col-8]="
                        (screenWidthPx$ | async | notNull) < 1630 &&
                        (screenWidthPx$ | async | notNull) >= 1280
                    "
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 1280"
                >
                    <aging-summary-scf
                        [dataSourceAllInvoices]="agingOverviewDataSourceAllInvoices"
                        [dataSourcePayLaterOnly]="
                            agingOverviewDataSourcePayLaterOnly$ | async | notNull
                        "
                        [invoicesUrl]="(invoicesUrl$ | async)!"
                    >
                    </aging-summary-scf>
                </div>

                <div
                    class="overview-column early-payment-table-extend"
                    [class.col-4]="
                        (screenWidthPx$ | async | notNull) < 1630 &&
                        (screenWidthPx$ | async | notNull) >= 1280
                    "
                    [class.col-6]="
                        (screenWidthPx$ | async | notNull) >= 1630 ||
                        ((screenWidthPx$ | async | notNull) < 1280 &&
                            (screenWidthPx$ | async | notNull) >= 1170)
                    "
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 1170"
                >
                    <early-payment-table
                        [listSuppliersDataSource]="suppliersTableDataSource"
                    ></early-payment-table>
                </div>
                <div
                    class="overview-column"
                    [class.col-6]="
                        (screenWidthPx$ | async | notNull) < 1280 &&
                        (screenWidthPx$ | async | notNull) >= 1170
                    "
                    [class.col-12]="
                        (screenWidthPx$ | async | notNull) >= 1280 ||
                        (screenWidthPx$ | async | notNull) < 1170
                    "
                >
                    <buyer-invoices-payable-table
                        [listInvoicesDataSource]="topAgingInvoicesTableDataSource"
                    >
                    </buyer-invoices-payable-table>
                </div>
            </div>

            <ng-container *ngIf="!(isBuyerUser$ | async)">
                <div class="row">
                    <div class="overview-column col-12">
                        <account-business-units-table
                            [dataSource]="businessUnitsTableDataSource"
                        ></account-business-units-table>
                    </div>
                </div>
            </ng-container>
        </ng-container>
        <ng-container *ngIf="!(isPayLaterEnabledForBuyer$ | async)">
            <div class="row">
                <div
                    class="overview-column"
                    [class.col-6]="(screenWidthPx$ | async | notNull) >= 1360"
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 1360"
                >
                    <aging-summary-scf
                        [dataSourceAllInvoices]="agingOverviewDataSourceAllInvoices"
                        [dataSourcePayLaterOnly]="
                            agingOverviewDataSourcePayLaterOnly$ | async | notNull
                        "
                        [invoicesUrl]="(invoicesUrl$ | async)!"
                    >
                    </aging-summary-scf>
                </div>
                <div
                    class="overview-column"
                    [class.col-3]="(screenWidthPx$ | async | notNull) >= 1360"
                    [class.col-6]="
                        (screenWidthPx$ | async | notNull) < 1360 &&
                        (screenWidthPx$ | async | notNull) >= 768
                    "
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 768"
                >
                    <facility-utilization-ft-tile
                        id="facility-utilization-ft-tile"
                        [earlyPaymentDataSource]="facilityUtilizationData"
                        [flexTermDataSource]="flexTermFacilityUtilizationData"
                    ></facility-utilization-ft-tile>
                </div>
                <div
                    class="overview-column"
                    [class.col-3]="(screenWidthPx$ | async | notNull) >= 1360"
                    [class.col-6]="
                        (screenWidthPx$ | async | notNull) < 1360 &&
                        (screenWidthPx$ | async | notNull) >= 768
                    "
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 768"
                >
                    <account-supplier-summary-tile
                        id="supplier-summary-tile"
                        [dataSource]="supplierOverviewDataSource"
                        [isBuyerAccount]="!(isBuyerUser$ | async)"
                    ></account-supplier-summary-tile>
                </div>
            </div>

            <div class="row">
                <div
                    class="overview-column"
                    [class.col-6]="(screenWidthPx$ | async | notNull) >= 992"
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 992"
                >
                    <buyer-invoices-payable-table
                        [listInvoicesDataSource]="topAgingInvoicesTableDataSource"
                    >
                    </buyer-invoices-payable-table>
                </div>
                <div
                    class="overview-column"
                    [class.col-6]="(screenWidthPx$ | async | notNull) >= 992"
                    [class.col-12]="(screenWidthPx$ | async | notNull) < 992"
                >
                    <early-payment-table
                        [listSuppliersDataSource]="suppliersTableDataSource"
                    ></early-payment-table>
                </div>
            </div>

            <ng-container *ngIf="!(isBuyerUser$ | async)">
                <div class="row">
                    <div class="overview-column col-12">
                        <account-business-units-table
                            [dataSource]="businessUnitsTableDataSource"
                        ></account-business-units-table>
                    </div>
                </div>
            </ng-container>
        </ng-container>
    </ng-container>
</div>
